import Button from '@mui/material/Button';
import React from 'react';
import Link from '~/components/Link';
import { ROUTES } from '~/constants/ROUTES';
import TAG_IDS from '~/constants/TAG_IDS';
import { RootTypography, RootTypographyTitle } from './styles';
const Render404 = (): React.ReactElement => <>
    <RootTypographyTitle variant="h4" data-sentry-element="RootTypographyTitle" data-sentry-source-file="index.tsx">Page not found.</RootTypographyTitle>

    <RootTypography variant="body1" data-sentry-element="RootTypography" data-sentry-source-file="index.tsx">
      The page you were looking for does not exist, or it may be private.
    </RootTypography>

    <RootTypography data-sentry-element="RootTypography" data-sentry-source-file="index.tsx">
      <Link href={ROUTES.INDEX} id={TAG_IDS.PAGE_NOT_FOUND_404.NOT_FOUND_HOME_LINK} underline="none" data-sentry-element="Link" data-sentry-source-file="index.tsx">
        <Button id={TAG_IDS.PAGE_NOT_FOUND_404.NOT_FOUND_HOME_LINK_BUTTON} variant="contained" data-sentry-element="Button" data-sentry-source-file="index.tsx">
          Return Home
        </Button>
      </Link>
    </RootTypography>
  </>;
export default Render404;